<template>
  <div>
    <div class="contentBox w">
      <div class="contentStitle">BPO Business process outsourcing</div>
      <div class="contentTitle">BPO商业流程外包</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="yjh_item">
        <div class="yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
        <div class="yjh_item_text text_right">
          <div class="text_box">
            <div class="text_line"></div>
            <div class="text_title">BPO商业流程外包简介！</div>
          </div>
          <div class="text_content">
            云久鸿为您提供全面、专业的外包服务，帮助企业把非核心岗位或业务流程分离出去。通过专业的人员管理以及规范化的操作流程，简化企业的用工程序，减少人员管理的成本。同时以先进的IT技术和系统支持，降低企业的用工风险、提升企业管理效率，使企业将精力投入到更有价值的核心业务中，创造更大的效益。
          </div>
          <div class="text_otal">
            优势：提升运营效率，节约成本；优化业务流程架构；实现企业卓越运营，提升行业竞争力；持续创新，帮助企业实现数字化转型。
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_contentBox">
      <div class="contentTitle noStitle">BPO商业流程外包</div>
      <div class="contentLine">
        <span class="lineLeft"></span>
        <span class="lineMiddle"></span>
        <span class="lineRight"></span>
      </div>
      <div class="mobile_yjh_item">
        <div class="mobile_yjh_item_text">
          <div class="text_line"></div>
          <div class="text_title">BPO商业流程外包简介！</div>
        </div>
        <div class="mobile_yjh_item_content">
          云久鸿为您提供全面、专业的外包服务，帮助企业把非核心岗位或业务流程分离出去。通过专业的人员管理以及规范化的操作流程，简化企业的用工程序，减少人员管理的成本。同时以先进的IT技术和系统支持，降低企业的用工风险、提升企业管理效率，使企业将精力投入到更有价值的核心业务中，创造更大的效益。
        </div>
        <div class="mobile_yjh_item_otal">
          优势：提升运营效率，节约成本；优化业务流程架构；实现企业卓越运营，提升行业竞争力；持续创新，帮助企业实现数字化转型。
        </div>
        <div class="mobile_yjh_item_img">
          <img :src="src.qyfw" alt srcset />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
}
</script>

<style lang="less" scoped></style>
